import Flickity from 'flickity';

const MediaColumnsSlider = () => {

    const sliders = document.querySelectorAll('[data-media-columns]');

    Array.from(sliders).forEach(slider => {

        if (typeof slider != "undefined" && slider != null) {

            // Flickity options, defaults
            var options = {
                cellSelector: '.media-columns__col',
                adaptiveHeight: false,
                cellAlign: 'left',
                contain: false,
                pageDots: false,
                prevNextButtons: true,
                watchCSS: true,
                wrapAround: false,
                arrowShape: 'M51.1317 04.99879L07.14271 49.9988C18.1775 61.2566 40.0974 83.7408 51.1317 94.9988L56.6828 89.4128C46.7597 79.2878 33.6297 65.8028 22.0455 53.9748L127.143 53.9748L127.143 46.0294L22.0455 46.0294L56.6828 10.6474L51.1317 04.99879Z'
            };

            // enable prev/next buttons at 768px
            if ( matchMedia('screen and (min-width: 768px)').matches ) {
                options.wrapAround = true;
            }

            new Flickity( slider, options);

            // Look for all Media Column elements that have aria-hidden="true" and change to aria-hidden="false"
            const mediaColumnsCols = slider.querySelectorAll('.media-columns__col[aria-hidden="true"]');
            Array.from(mediaColumnsCols).forEach(mediaColumnsCol => {
                    mediaColumnsCol.setAttribute('aria-hidden', 'false');
                }
            );
        }
    });
}

export default MediaColumnsSlider;
